/* HolyGlow - custom verse engraving (per-plate aware) */
(function () {
  'use strict';
  var CFG = window.HG_VERSE_CFG || {};
  var MAX = CFG.maxLength || 40;
  var IDS = {};
  (CFG.variantIds || []).forEach(function (id) { IDS[String(id)] = true; });

  var state = { on: false, texts: [] };
  var lastCount = 1;

  function kblock() { return document.querySelector('kaching-bundles-block'); }

  function plateCount() {
    var k = kblock();
    if (!k) return 1;
    var vis = [].slice.call(k.querySelectorAll('select')).filter(function (s) { return s.offsetParent !== null; });
    return vis.length > 0 ? vis.length : 1;
  }

  function injectStyles() {
    if (document.getElementById('hg-verse-styles')) return;
    var s = document.createElement('style');
    s.id = 'hg-verse-styles';
    s.textContent = [
      '.hg-verse{border:1.5px solid #e6dcfb;border-radius:12px;padding:14px 16px;margin:16px 0;background:#faf7ff;font-family:inherit;}',
      '.hg-verse__row{display:flex;align-items:flex-start;gap:10px;cursor:pointer;}',
      '.hg-verse__cb{width:18px;height:18px;margin:1px 0 0;flex:0 0 auto;accent-color:#7c3aed;cursor:pointer;}',
      '.hg-verse__label{font-size:15px;font-weight:600;color:#160b2b;line-height:1.35;}',
      '.hg-verse__note{display:block;font-weight:400;font-size:13px;color:#6b6480;margin-top:2px;}',
      '.hg-verse__body{margin-top:12px;display:none;}',
      '.hg-verse.is-on .hg-verse__body{display:block;}',
      '.hg-verse__field{margin-bottom:10px;}',
      '.hg-verse__field:last-of-type{margin-bottom:0;}',
      '.hg-verse__cap{display:block;font-size:12.5px;font-weight:600;color:#160b2b;margin-bottom:5px;}',
      '.hg-verse__input{width:100%;box-sizing:border-box;padding:11px 13px;border:1.5px solid #d9cdf7;border-radius:9px;font-size:15px;color:#160b2b;background:#fff;font-family:inherit;}',
      '.hg-verse__input:focus{outline:none;border-color:#7c3aed;box-shadow:0 0 0 3px rgba(124,58,237,.15);}',
      '.hg-verse__field.is-bad .hg-verse__input{border-color:#d92d20;}',
      '.hg-verse__meta{display:flex;justify-content:space-between;gap:12px;margin-top:5px;font-size:12px;color:#6b6480;line-height:1.45;}',
      '.hg-verse__count{flex:0 0 auto;font-variant-numeric:tabular-nums;}',
      '.hg-verse__same{margin:2px 0 12px;font-size:13px;color:#7c3aed;background:none;border:0;padding:0;cursor:pointer;font-weight:600;text-decoration:underline;font-family:inherit;display:none;}',
      '.hg-verse.is-multi .hg-verse__same{display:inline-block;}',
      '.hg-verse__err{display:none;margin-top:8px;font-size:13px;color:#d92d20;font-weight:500;}',
      '.hg-verse.has-error .hg-verse__err{display:block;}',
      '.hg-verse__foot{margin-top:9px;font-size:12.5px;color:#6b6480;line-height:1.45;}'
    ].join('');
    document.head.appendChild(s);
  }

  function fieldHTML(i, n) {
    var cap = n > 1 ? ('Plate ' + (i + 1) + ' verse') : '';
    return '<div class="hg-verse__field" data-i="' + i + '">' +
      (cap ? '<span class="hg-verse__cap">' + cap + '</span>' : '') +
      '<input type="text" class="hg-verse__input" maxlength="' + MAX + '" placeholder="e.g. Jeremiah 29:11" autocomplete="off">' +
      '<div class="hg-verse__meta"><span></span><span class="hg-verse__count">0/' + MAX + '</span></div>' +
    '</div>';
  }

  function build(n) {
    var w = document.createElement('div');
    w.className = 'hg-verse' + (n > 1 ? ' is-multi' : '');
    w.id = 'hg-verse';
    var fields = '';
    for (var i = 0; i < n; i++) fields += fieldHTML(i, n);
    w.innerHTML =
      '<label class="hg-verse__row">' +
        '<input type="checkbox" class="hg-verse__cb" id="hg-verse-cb">' +
        '<span class="hg-verse__label">Engrave my own verse instead' +
          '<span class="hg-verse__note">Any verse you like, in place of the one selected above. No extra cost.</span>' +
        '</span>' +
      '</label>' +
      '<div class="hg-verse__body">' +
        fields +
        '<button type="button" class="hg-verse__same">Use the same verse on all plates</button>' +
        '<div class="hg-verse__foot">Engraved exactly as you type it \u2014 please double-check spelling.</div>' +
        '<div class="hg-verse__err">Please fill in a verse for every plate.</div>' +
      '</div>';
    return w;
  }

  function fields(el) { return [].slice.call(el.querySelectorAll('.hg-verse__field')); }

  function wire(el) {
    var cb = el.querySelector('#hg-verse-cb');
    cb.addEventListener('change', function () {
      state.on = cb.checked;
      el.classList.toggle('is-on', state.on);
      clearErr(el);
      if (state.on) { try { el.querySelector('.hg-verse__input').focus(); } catch (e) {} }
    });

    fields(el).forEach(function (f) {
      var i = +f.getAttribute('data-i');
      var input = f.querySelector('.hg-verse__input');
      var cnt = f.querySelector('.hg-verse__count');
      input.addEventListener('input', function () {
        state.texts[i] = input.value.replace(/\s+/g, ' ').trim();
        cnt.textContent = input.value.length + '/' + MAX;
        if (state.texts[i]) f.classList.remove('is-bad');
        clearErrIfAllOk(el);
      });
    });

    var same = el.querySelector('.hg-verse__same');
    if (same) same.addEventListener('click', function () {
      var first = el.querySelector('.hg-verse__input').value;
      fields(el).forEach(function (f) {
        var i = +f.getAttribute('data-i');
        var input = f.querySelector('.hg-verse__input');
        input.value = first;
        state.texts[i] = first.replace(/\s+/g, ' ').trim();
        f.querySelector('.hg-verse__count').textContent = first.length + '/' + MAX;
        f.classList.remove('is-bad');
      });
      clearErrIfAllOk(el);
    });
  }

  function clearErr(el) {
    el.classList.remove('has-error');
    fields(el).forEach(function (f) { f.classList.remove('is-bad'); });
  }
  function clearErrIfAllOk(el) {
    var n = fields(el).length, ok = true;
    for (var i = 0; i < n; i++) if (!state.texts[i]) ok = false;
    if (ok) el.classList.remove('has-error');
  }

  function restore(el) {
    var n = fields(el).length;
    el.classList.toggle('is-on', state.on);
    el.querySelector('#hg-verse-cb').checked = state.on;
    fields(el).forEach(function (f) {
      var i = +f.getAttribute('data-i');
      var v = state.texts[i] || '';
      f.querySelector('.hg-verse__input').value = v;
      f.querySelector('.hg-verse__count').textContent = v.length + '/' + MAX;
    });
    state.texts.length = n;
  }

  function anchor() {
    var k = kblock();
    if (k) return { node: k, where: 'after' };
    var form = document.querySelector('form[action*="/cart/add"]');
    if (form) {
      var btn = form.querySelector('[type="submit"], button[name="add"]');
      if (btn) return { node: btn, where: 'before' };
      return { node: form, where: 'append' };
    }
    return null;
  }

  function place() {
    var n = plateCount();
    var existing = document.getElementById('hg-verse');
    if (existing && fields(existing).length === n) return true;
    var a = anchor(); if (!a) return false;
    injectStyles();
    var el = build(n);
    if (existing) existing.parentNode.replaceChild(el, existing);
    else if (a.where === 'after') a.node.parentNode.insertBefore(el, a.node.nextSibling);
    else if (a.where === 'before') a.node.parentNode.insertBefore(el, a.node);
    else a.node.appendChild(el);
    wire(el);
    restore(el);
    lastCount = n;
    return true;
  }

  function verses() {
    var n = plateCount(), out = [];
    for (var i = 0; i < n; i++) out.push(state.texts[i] || '');
    return out;
  }
  function active() { return state.on && verses().every(function (v) { return !!v; }); }
  function blocking() { return state.on && !verses().every(function (v) { return !!v; }); }

  function flagError() {
    var el = document.getElementById('hg-verse'); if (!el) return;
    el.classList.add('has-error');
    fields(el).forEach(function (f) {
      var i = +f.getAttribute('data-i');
      if (!state.texts[i]) f.classList.add('is-bad');
    });
    try {
      el.scrollIntoView({ behavior: 'smooth', block: 'center' });
      var bad = el.querySelector('.hg-verse__field.is-bad .hg-verse__input');
      if (bad) bad.focus();
    } catch (e) {}
  }

  function ours(id) { if (!Object.keys(IDS).length) return true; return !!IDS[String(id)]; }

  function tagPayload(o) {
    if (!o || typeof o !== 'object') return o;
    var vs = verses();
    var list = Array.isArray(o.items) ? o.items : [o];
    var cursor = 0;
    list.forEach(function (it) {
      if (!it || typeof it !== 'object') return;
      var id = it.id != null ? it.id : it.variant_id;
      if (!ours(id)) return;
      var qty = parseInt(it.quantity, 10) || 1;
      it.properties = it.properties || {};
      var mine = vs.slice(cursor, cursor + qty);
      if (mine.length <= 1) {
        it.properties['Custom Verse'] = mine[0] || vs[0] || '';
      } else {
        mine.forEach(function (v, j) { it.properties['Verse ' + (j + 1)] = v; });
      }
      cursor += qty;
    });
    return o;
  }

  function isAddUrl(u) { try { return typeof u === 'string' && u.indexOf('/cart/add') !== -1; } catch (e) { return false; } }

  var origFetch = window.fetch;
  if (origFetch) {
    window.fetch = function (input, init) {
      var url = typeof input === 'string' ? input : (input && input.url) || '';
      if (isAddUrl(url)) {
        if (blocking()) { flagError(); return Promise.reject(new Error('custom verse incomplete')); }
        if (active() && init && init.body) {
          try {
            if (typeof init.body === 'string') init = Object.assign({}, init, { body: JSON.stringify(tagPayload(JSON.parse(init.body))) });
          } catch (e) {}
        }
      }
      return origFetch.apply(this, [input, init]);
    };
  }

  var OPEN = XMLHttpRequest.prototype.open, SEND = XMLHttpRequest.prototype.send;
  XMLHttpRequest.prototype.open = function (m, u) { this.__hgAdd = isAddUrl(u); return OPEN.apply(this, arguments); };
  XMLHttpRequest.prototype.send = function (body) {
    if (this.__hgAdd) {
      if (blocking()) { flagError(); return; }
      if (active() && body) {
        try { if (typeof body === 'string' && body.charAt(0) === '{') body = JSON.stringify(tagPayload(JSON.parse(body))); } catch (e) {}
      }
    }
    return SEND.call(this, body);
  };

  document.addEventListener('submit', function (e) {
    var f = e.target;
    if (!f || !f.action || f.action.indexOf('/cart/add') === -1) return;
    if (blocking()) { e.preventDefault(); flagError(); return; }
    if (!active()) return;
    var vs = verses();
    [].slice.call(f.querySelectorAll('input[data-hg-prop]')).forEach(function (x) { x.remove(); });
    vs.forEach(function (v, j) {
      var h = document.createElement('input');
      h.type = 'hidden';
      h.setAttribute('data-hg-prop', '1');
      h.name = 'properties[' + (vs.length > 1 ? 'Verse ' + (j + 1) : 'Custom Verse') + ']';
      h.value = v;
      f.appendChild(h);
    });
  }, true);

  function boot() {
    if (place()) return;
    var t = 0;
    var iv = setInterval(function () { if (place() || ++t > 40) clearInterval(iv); }, 250);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();

  // tier changes / widget re-renders
  var mo = new MutationObserver(function () {
    if (!document.getElementById('hg-verse') || plateCount() !== lastCount) place();
  });
  mo.observe(document.documentElement, { childList: true, subtree: true, attributes: true, attributeFilter: ['style', 'class'] });
  document.addEventListener('change', function (e) {
    if (e.target && e.target.closest && e.target.closest('kaching-bundles-block')) setTimeout(place, 150);
  }, true);
})();
